
<template>
    <div class="section">
        <div class="container">
            <div class="columns account-header is-auth">
                <div class="column main-column is-tablet-landscape-padded">
                    <div class="auth-title">
                        <img :src="require('../../assets/images/cropped-logotipo-bambi.png')" alt="logo" class="brand-filigrane">
                    </div>
                    <div class="main-auth-wrapper">

                        <div class="registration-form-wrapper">
                            <!--Registration form-->
                            <div class="registration-form">
                                <form @submit.prevent="submit">

                                    <h3>
                                        Bienvenido
                                    </h3>
                                    <p class="form-description">
                                        Antes de poder utilizar el sistema debe modificar su contraseña.
                                    </p>
                                    <p class="form-description">
                                        Esto se debe a que es la primera vez que ingresa o se ha reseteado su contraseña recientemente.
                                    </p>

                                    <!--Field-->
                                    <div class="field">
                                        <label>Contraseña</label>
                                        <div class="control is-bigger has-icon">
                                            <input class="input" type="password" name="password" id="password" v-model="form.password">
                                            <div class="form-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!--Field-->
                                    <div class="field">
                                        <label>Repetir Contraseña</label>
                                        <div class="control is-bigger has-icon">
                                            <input class="input" type="password" name="password_confirmation" id="password_confirmation" v-model="form.password_confirmation">
                                            <div class="form-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                            </div>
                                        </div>
                                    </div>

                                    <!--Submit-->
                                    <div class="button-wrap">
                                        <button type="submit" class="button primary-button upper-button raised is-fullwidth is-rounded">Guardar Cambios</button>
                                    </div>

                                    <div class="back-link has-text-centered">
                                        <a href="#" @click.prevent="signOut">Volver al Login</a>                                        
                                    </div>
                                </form>
                                <small class="has-text-danger"><em>{{errors}}</em></small>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'register',
    created(){
        this.clearAuthErrors()
    },
    data(){
        return{
            form:{
                password: '',
                password_confirmation: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            errors: 'auth/errors',
        }),
    },    
    methods:{
        ...mapActions({
            clearAuthErrors: 'auth/clearAuthErrors',
            signOutAction: 'auth/signOut',
            changePassword: 'auth/changePassword',
        }),

        submit(){
            this.changePassword(this.form)
                .then(() => {
                    this.form.password = '';
                    this.form.password_confirmation = '';
                    this.$router.replace({
                        name: 'home'
                    })                    
                }).catch(() => {
                    console.log("Fallo al guardar!");
                })
        },
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'auth.login'
                })
            })
        },        
    }
}
</script>

<style>
    .auth-title .brand-filigrane {
        opacity: 1;
    }
    .registration-form h3{
        text-align: center;
        margin-bottom: 25px;
        font-weight: 800;
        font-size: 110%;
    }
</style>